export default __webpack_public_path__ + "static/media/blog_grid_5.be173d53.jpg";